import { assets } from "@/lib/assets";
import { ArrowRight, Sparkles } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-32 md:pt-40 pb-20 md:pb-28"
    >
      {/* Decorative accents */}
      <div className="hero-orb -top-20 -right-40 hidden md:block" aria-hidden />
      <div
        className="absolute inset-x-0 top-0 h-[540px] -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(1200px 500px at 20% 0%, rgba(56,189,248,0.10), transparent 60%), radial-gradient(900px 500px at 100% 0%, rgba(10,25,47,0.06), transparent 60%)",
        }}
        aria-hidden
      />

      <div className="kat-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        <div className="lg:col-span-7 reveal-up">
          <div className="inline-flex items-center gap-2 border border-slate-200 bg-white/70 backdrop-blur px-3.5 py-1.5 rounded-full mb-8">
            <Sparkles size={14} className="text-[color:var(--kat-sky-deep)]" />
            <span className="text-[11px] tracking-[0.24em] uppercase font-semibold text-[color:var(--kat-navy)]">
              Minority-Owned · Nationally Focused
            </span>
          </div>

          <h1 className="font-serif text-[44px] sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[color:var(--kat-navy)]">
            Lead with{" "}
            <span className="italic text-[color:var(--kat-sky-deep)]">clarity.</span>
            <br />
            Grow with{" "}
            <span className="italic" style={{ color: "var(--kat-orange)" }}>confidence.</span>
            <br />
            Build with <span className="italic" style={{ color: "var(--kat-navy)" }}>purpose.</span>
          </h1>

          <p className="mt-8 text-lg md:text-xl leading-relaxed text-[color:var(--kat-muted)] max-w-2xl">
            KAT Consulting & Branding Inc. partners with organizations, entrepreneurs,
            and communities — pairing high-impact professional development with real
            operational muscle in bookkeeping and short-term rental strategy.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-[color:var(--kat-navy)] hover:bg-[color:var(--kat-navy-2)] text-white text-sm font-medium tracking-wide px-8 py-4 rounded-sm transition-all kat-focus"
            >
              Start the Conversation
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-3 border border-[color:var(--kat-navy)] text-[color:var(--kat-navy)] hover:bg-[color:var(--kat-navy)] hover:text-white text-sm font-medium tracking-wide px-8 py-4 rounded-sm transition-all kat-focus"
            >
              Explore Our Divisions
            </a>
          </div>

          {/* Trust bar */}
          <dl className="mt-14 grid grid-cols-3 max-w-xl gap-8 border-t border-slate-200 pt-8">
            <div>
              <dt className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--kat-muted)] font-semibold">Practices</dt>
              <dd className="mt-2 font-serif text-3xl text-[color:var(--kat-navy)]">03</dd>
              <p className="text-xs text-[color:var(--kat-muted)] mt-1">Divisions under one roof</p>
            </div>
            <div>
              <dt className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--kat-muted)] font-semibold">Focus</dt>
              <dd className="mt-2 font-serif text-3xl text-[color:var(--kat-navy)]">1:1</dd>
              <p className="text-xs text-[color:var(--kat-muted)] mt-1">Guidance & Strategy</p>
            </div>
            <div>
              <dt className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--kat-muted)] font-semibold">Mandate</dt>
              <dd className="mt-2 font-serif text-3xl text-[color:var(--kat-navy)]">100%</dd>
              <p className="text-xs text-[color:var(--kat-muted)] mt-1">Sustainable growth</p>
            </div>
          </dl>
        </div>

        {/* Hero visual */}
        <div className="lg:col-span-5 relative reveal-up" style={{ animationDelay: "180ms" }}>
          <div className="relative aspect-[3/4] md:aspect-[4/5] w-full max-w-md mx-auto lg:ml-auto">
            <div
              className="absolute -inset-6 rounded-md -z-10"
              style={{ background: "linear-gradient(135deg,#0A192F 0%,#38BDF8 100%)" }}
              aria-hidden
            />
            <img
              src={assets.founderWhite}
              alt="Karlene A Thomas, BSc. — Founder of KAT Consulting & Branding Inc."
              data-testid="hero-image"
              className="relative w-full h-full object-cover object-[center_20%] md:object-center rounded-md shadow-2xl"
            />
            {/* Overlay card */}
            <div
              className="absolute -bottom-8 -left-8 md:-left-14 bg-white border border-slate-200 shadow-xl rounded-sm p-5 max-w-[220px]"
              data-testid="hero-overlay-card"
            >
              <p className="overline text-[color:var(--kat-sky-deep)]">Tagline</p>
              <p className="mt-2 font-serif text-2xl leading-tight text-[color:var(--kat-navy)]">
                Clarity, Confidence, Purpose.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
